<template>
  <div class="warp">
    <div class="container">
      <div class="video-wrapper">
        <video ref="video1" id="my-video-1" class="video-play video-js aos-init aos-animate" data-aos="fade-in" muted playsinline controls loop preload="auto">
          <source src="@/assets/sub-video/video1.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="video-wrapper">
        <video ref="video2" id="my-video-2" class="video-play video-js aos-init aos-animate" data-aos="fade-in" muted playsinline loop controls preload="auto">
          <source src="@/assets/sub-video/video2.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="row d-flex justify-content-center">
          <button type="button" class="next-btn" @click="goToTargetPage(2)">這是什麼！？</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'NavbarComponent',
  props: {
    activePage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      activePageNum: 0,
      lastScrollTop: 0,
      debounceTimeout: null,
      debounceDelay: 50, 
      var1: false,
      var2: false,
      var3: false,
      var4: false,
      var5: false,
      var6: false
    };
  },
  mounted() {
    this.setupIntersectionObserver();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    this.var1 = localStorage.getItem('var1');
    this.var2 = localStorage.getItem('var2');
    this.var3 = localStorage.getItem('var3');
    this.var4 = localStorage.getItem('var4');
    this.var5 = localStorage.getItem('var5');
    this.var6 = localStorage.getItem('var6');
  },
  methods: {
    goToTargetPage(num) {
      this.$emit('updatePageIndex', num);
      this.activePageNum = num;
      this.$router.push({ name: 'SubPage' + num });
      this.saveVariablesToLocalStorage();
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };

      const callback = (entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      };

      const observer = new IntersectionObserver(callback, options);
      this.$refs.video1 && observer.observe(this.$refs.video1);
      this.$refs.video2 && observer.observe(this.$refs.video2);
    },
    handleScroll() {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > this.lastScrollTop) {
          this.positionVideo('down');
        } else if (scrollTop < this.lastScrollTop) {
          this.positionVideo('up');
        }
        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }, this.debounceDelay);
    },
    positionVideo(direction) {
      const videos = [this.$refs.video1, this.$refs.video2];
      const viewportHeight = window.innerHeight;
      
      let visibleVideo = null;
      for (let video of videos) {
        if (video) {
          const videoRect = video.getBoundingClientRect();
          if (videoRect.top <= viewportHeight && videoRect.bottom >= 0) {
            visibleVideo = video;
            break;
          }
        }
      }

      if (visibleVideo) {
        let targetVideo = null;
        if (direction === 'down') {
          targetVideo = (visibleVideo === this.$refs.video1) ? this.$refs.video2 : null;
        } else if (direction === 'up') {
          targetVideo = (visibleVideo === this.$refs.video2) ? this.$refs.video1 : null;
        }

        if (targetVideo) {
          const targetVideoRect = targetVideo.getBoundingClientRect();
          const targetScrollToPosition = window.scrollY + targetVideoRect.top - (viewportHeight / 2) + (targetVideoRect.height / 2);

          // 限制最大滚动距离
          const maxScrollDistance = 1000; // 根据需要调整
          const scrollDistance = Math.abs(targetScrollToPosition - window.scrollY);
          const limitedScrollDistance = Math.min(scrollDistance, maxScrollDistance);

          window.scrollTo({
            top: window.scrollY + (targetScrollToPosition > window.scrollY ? limitedScrollDistance : -limitedScrollDistance),
            behavior: 'smooth'
          });
        }
      }
    },
    saveVariablesToLocalStorage() {
      localStorage.setItem('var1', this.var1);
      localStorage.setItem('var2', this.var2);
      localStorage.setItem('var3', this.var3);
      localStorage.setItem('var4', this.var4);
      localStorage.setItem('var5', this.var5);
      localStorage.setItem('var6', this.var6);
    },

  }
}
</script>



<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@500&display=swap');

.warp {
  font-family: "Noto Sans TC", sans-serif;
  overflow: hidden;
}

.container {
  display: flex;
  flex-direction: column;
}

.video-wrapper {
  flex: 0 0 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-play {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.next-btn {
  width: 250px;
  height: 100px;
  margin-top: 2rem;
  margin-bottom: 4rem;
  border-radius: 10px;
  font-size: 28px;
  background-color: #008aac;
  border: none;
  color: #fff;
  transition: all .3s ease;
  &:hover {
    color: #008aac;
    background-color: #fff;
    border: 1px solid #008aac;
  }
}


</style>

